webpackJsonp([12],{

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrabajoPage_vue_vue_type_script_lang_js___ = __webpack_require__(532);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TrabajoPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "49c12c1b",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TrabajoPage_vue_vue_type_script_lang_js___ = __webpack_require__(533);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TrabajoPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_DatosTrabajo__ = __webpack_require__(656);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrabajoPage',
  components: {
    DatosTrabajo: __WEBPACK_IMPORTED_MODULE_0__components_forms_DatosTrabajo__["a" /* default */]
  }
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DatosTrabajo_vue_vue_type_script_lang_js___ = __webpack_require__(535);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DatosTrabajo_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DatosTrabajo',
  created: function created() {
    this.loadCatalogos();
    this.loadDatosTrabajo();
  },
  data: function data() {
    return {
      valid: false,
      cargandoDatos: false,
      guardarLoading: false,
      snackbar: false,
      snackbarMensaje: '',
      estados: [],
      turnos: [{
        id: 1,
        descripcion: 'Matutino'
      }, {
        id: 2,
        descripcion: 'Vespertino'
      }, {
        id: 3,
        descripcion: 'Mixto'
      }],
      datosTrabajo: {}
    };
  },
  methods: {
    loadCatalogos: function loadCatalogos() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('catalogo/estados').then(function (resp) {
        _this.estados = resp.data.estados;
      }).catch(function (err) {
        console.log(err);
      });
    },
    loadDatosTrabajo: function loadDatosTrabajo() {
      var _this2 = this;
      this.cargandoDatos = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('alumno/datos-trabajo').then(function (resp) {
        _this2.cargandoDatos = false;
        _this2.datosTrabajo = resp.data.datosTrabajo;
      });
    },
    guardar: function guardar() {
      var _this3 = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('alumno/datos-trabajo', this.datosTrabajo).then(function (resp) {
        _this3.snackbar = true;
        _this3.snackbarMensaje = 'Los datos se guardaron correctamente';
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___ = __webpack_require__(655);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_TrabajoPage_vue_vue_type_template_id_49c12c1b_scoped_true___["b"]; });


/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"md12":""}},[_c('datos-trabajo')],1)],1)],1)
}
var staticRenderFns = []



/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatosTrabajo_vue_vue_type_script_lang_js___ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DatosTrabajo_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "b1bb4362",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___ = __webpack_require__(658);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_DatosTrabajo_vue_vue_type_template_id_b1bb4362_scoped_true___["b"]; });


/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Información de Trabajo")])])]),_vm._v(" "),(!_vm.cargandoDatos)?_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Nombre de la empresa","required":"","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.nombre),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "nombre", $$v)},expression:"datosTrabajo.nombre"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Teléfono","mask":'phone',"autocomplete":"nope","required":""},model:{value:(_vm.datosTrabajo.telefono),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "telefono", $$v)},expression:"datosTrabajo.telefono"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Domicilio (Calle y Número)","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.domicilio),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "domicilio", $$v)},expression:"datosTrabajo.domicilio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Colonia","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.colonia),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "colonia", $$v)},expression:"datosTrabajo.colonia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Ciudad","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.ciudad),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "ciudad", $$v)},expression:"datosTrabajo.ciudad"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{attrs:{"items":_vm.estados,"item-value":"id","item-text":"nombre","label":"Estado"},model:{value:(_vm.datosTrabajo.estado),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "estado", $$v)},expression:"datosTrabajo.estado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Puesto que ocupa","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.puesto),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "puesto", $$v)},expression:"datosTrabajo.puesto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Antigüedad","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.ant),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "ant", $$v)},expression:"datosTrabajo.ant"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Nombre del Jefe Inmediato Supervisor","autocomplete":"nope"},model:{value:(_vm.datosTrabajo.nombreJefe),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "nombreJefe", $$v)},expression:"datosTrabajo.nombreJefe"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.turnos,"item-value":"id","item-text":"descripcion","label":"Turno"},model:{value:(_vm.datosTrabajo.turno),callback:function ($$v) {_vm.$set(_vm.datosTrabajo, "turno", $$v)},expression:"datosTrabajo.turno"}})],1)],1)],1)],1):_c('v-progress-linear',{attrs:{"indeterminate":true}})],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-5"}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","loading":_vm.guardarLoading,"disabled":_vm.guardarLoading || !_vm.valid},on:{"click":_vm.guardar}},[_vm._v("Guardar")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":'success',"top":'top',"right":true},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarMensaje)+"\n        "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Cerrar")])],1)],1)
}
var staticRenderFns = []



/***/ })

});


// WEBPACK FOOTER //
// static/js/12.e414a7ac228825c04aa6.js